const getBrowserPreference = (): boolean => {
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
};

export const initializeDarkMode = () => {
    const html = document.documentElement;
    if (!localStorage.theme) {
        localStorage.theme = 'dark';
    }
    if (localStorage.theme === 'dark' || 
        (!localStorage.theme && getBrowserPreference())) {
        html.classList.add('dark');
    } else {
        html.classList.remove('dark');
    }
};

export const toggleDarkMode = () => {
    const html = document.documentElement;
    if (html.classList.contains('dark')) {
        html.classList.remove('dark');
        localStorage.theme = 'light';
    } else {
        html.classList.add('dark');
        localStorage.theme = 'dark';
    }
};